var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../../converters/DateConverter";
export class TokenInfo {
  constructor(_data) {
    /**
     */
    __publicField(this, "Expiration");
    /**
     */
    __publicField(this, "IsMissing");
    /**
     */
    __publicField(this, "IsValid");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof TokenInfo
     */
    __publicField(this, "$type", "V1.Cesop.Psps.Extensions.TokenInfo");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Expiration = DateConverter.from(_data["Expiration"]);
      this.IsMissing = _data["IsMissing"];
      this.IsValid = _data["IsValid"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Expiration"] = DateConverter.toIsoUtcString(this.Expiration);
    _data["IsMissing"] = this.IsMissing;
    _data["IsValid"] = this.IsValid;
    return _data;
  }
}
